import React, { useEffect } from 'react';
import '../cs/temp.css';
import AOS from "aos";
import "aos/dist/aos.css";

function NativeAppDevelopment() {
      useEffect(()=>{
        AOS.init({duration:1000, once:true});
      },[])
    return (
        <div className="webdev-page" style={{overflowX:"hidden"}}>
            <section className="inner-banner-wrap">
                <div
                    className="inner-baner-container"
                    style={{ backgroundImage: "url(assets/images/banner-pattern1.png)" }}
                >
                    <div className="container" data-aos="fade-up">
                        <div className="inner-banner-content">
                            <h1 className="inner-title">Native App Development</h1>
                        </div>
                    </div>
                </div>
            </section>

            {/* Our Services Section */}
            <section className="webdev-services-section">
                <div className="container">
                    <div className="section-header">
                        <h2 data-aos="fade-up">Our Native App Development Services</h2>
                        <p className="section-description">
                        We develop fully customized native mobile applications for both iOS and Android, utilizing platform-specific technologies to deliver unmatched performance, smooth functionality, and a premium user experience tailored to each platform’s strengths.                        </p>
                    </div>

                    <div className="services-grid" data-aos="fade-up-left" data-aos-delay="200">
                        <div className="service-card">
                            <div className="service-icon">
                                <i className="fab fa-apple"></i>
                            </div>
                            <h3>iOS Development</h3>
                            <p>Build exceptional iOS apps with Swift and SwiftUI, perfectly optimized for Apple’s ecosystem of iPhones and iPads.
</p>
                        </div>

                        <div className="service-card">
                            <div className="service-icon">
                                <i className="fab fa-android"></i>
                            </div>
                            <h3>Android Development</h3>
                            <p>Develop high-quality Android apps with Kotlin and Jetpack Compose, designed to perform seamlessly across all Android devices.
.</p>
                        </div>

                        <div className="service-card">
                            <div className="service-icon">
                                <i className="fas fa-tasks"></i>
                            </div>
                            <h3>Productivity Apps</h3>
                            <p>Create powerful productivity-focused applications that simplify workflows, improve efficiency, and add value to users’ daily lives.</p>
                        </div>

                        {/* <div className="service-card">
                            <div className="service-icon">
                                <i className="fas fa-heartbeat"></i>
                            </div>
                            <h3>Health & Wellness Apps</h3>
                            <p>Innovative solutions for fitness tracking, mental wellbeing, and lifestyle improvement.</p>
                        </div> */}
                    </div>
                </div>
            </section>

         
            {/* App Development Process Section */}
            <section className="design-process-section">
                <div className="container">
                    <div className="section-header">
                        <h2>Our Native App Development Process</h2>
                        <p className="section-description">
                            A meticulous approach to building high-quality native applications
                        </p>
                    </div>

                    <div className="process-timeline">
                        <div className="process-step" data-aos="fade-left" data-aos-delay="200">
                            <div className="step-number">1</div>
                            <div className="step-content">
                                <h3>Discovery & Planning</h3>
                                <p>Define your goals, audience, and technical needs to craft a clear strategy for your native app.</p>
                            </div>
                        </div>

                        <div className="process-step" data-aos="fade-left" data-aos-delay="200">
                            <div className="step-number">2</div>
                            <div className="step-content">
                                <h3>UI/UX Design</h3>
                                <p>Design interfaces that meet Apple’s Human Interface Guidelines and Google’s Material Design standards.</p>
                            </div>
                        </div>

                        <div className="process-step" data-aos="fade-left" data-aos-delay="200">
                            <div className="step-number">3</div>
                            <div className="step-content">
                                <h3>Native Development</h3>
                                <p>Build robust, platform-specific apps using Swift for iOS and Kotlin for Android, leveraging native features.</p>
                            </div>
                        </div>

                        <div className="process-step" data-aos="fade-left" data-aos-delay="300">
                            <div className="step-number">4</div>
                            <div className="step-content">
                                <h3>API Integration</h3>
                                <p>Integrate your app with APIs, backend systems, cloud services, and device-level hardware capabilities.</p>
                            </div>
                        </div>

                        <div className="process-step" data-aos="fade-left" data-aos-delay="300">
                            <div className="step-number">5</div>
                            <div className="step-content">
                                <h3>Quality Assurance</h3>
                                <p>Test extensively on physical devices to ensure optimal speed, stability, and full compliance with platform requirements.</p>
                            </div>
                        </div>

                        <div className="process-step" data-aos="fade-left" data-aos-delay="300">
                            <div className="step-number">6</div>
                            <div className="step-content">
                                <h3>App Store Deployment</h3>
                                <p>Publish your app seamlessly on the Apple App Store and Google Play Store with proper setup and support..</p>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
               {/* Key Features Section */}
               <section className="why-choose-section">
                <div className="container">
                    <div className="section-header">
                        <h2>Key Features of Our Native Apps</h2>
                        <p className="section-description">
                            Benefits that make native app development the preferred choice for superior mobile experiences
                        </p>
                    </div>

                    <div className="features-grid" data-aos="fade-up-left" data-aos-delay="300">
                        <div className="feature-card">
                            <div className="feature-icon text-center">
                                <i className="fab fa-app-store-ios"></i>
                            </div>
                            <h3>iOS App Development</h3>
                            <p>Premium apps crafted with Swift and SwiftUI, fully optimized for Apple hardware.</p>
                        </div>

                        <div className="feature-card">
                            <div className="feature-icon text-center">
                                <i className="fab fa-google-play"></i>
                            </div>
                            <h3>Android App Development</h3>
                            <p>High-performance Android apps built with Kotlin and Jetpack Compose.</p>
                        </div>

                        <div className="feature-card">
                            <div className="feature-icon text-center">
                                <i className="fas fa-palette"></i>
                            </div>
                            <h3>Platform-Specific UX</h3>
                            <p>Interfaces designed specifically for each platform to ensure familiarity and ease of use.</p>
                        </div>

                        <div className="feature-card">
                            <div className="feature-icon text-center">
                                <i className="fas fa-microchip"></i>
                            </div>
                            <h3>Hardware Integration</h3>
                            <p>Take advantage of native features like biometrics, GPS, cameras, and sensors.</p>
                        </div>

                        <div className="feature-card">
                            <div className="feature-icon text-center">
                                <i className="fas fa-tachometer-alt"></i>
                            </div>
                            <h3>Performance Optimization</h3>
                            <p>Fast, responsive apps with efficient resource management and smooth animations.</p>
                        </div>

                        <div className="feature-card">
                            <div className="feature-icon text-center">
                                <i className="fas fa-tools"></i>
                            </div>
                            <h3>App Maintenance</h3>
                            <p>Regular updates, security patches, and new feature integrations to keep your app competitive.</p>
                        </div>
                    </div>
                </div>
            </section>


            {/* CTA Section */}
            <section className="cta-section mt-5">
                <div className="container">
                    <div className="cta-content">
                        <h2>Ready to Build Your Native Mobile App?</h2>
                        <p>Let's create a powerful, platform-optimized application that delivers an exceptional user experience.</p>
                        <a href="/contact" className="cta-button">Get a Free Consultation</a>
                    </div>
                </div>
            </section>

        </div>
    );
}

export default NativeAppDevelopment;
